<template>
  <el-dialog
    :visible.sync="active"
    width="900px"
    title="图片详情"
    class="bigImageDialog"
    :close-on-press-escape="false"
    :close-on-click-modal="false"
    :append-to-body="true"
    :modal-append-to-body="true"
    @close="active = false"
    :center="true"
  >
    <div class="btn-container">
      <div class="roomIn btn" @click="roomIO('in')"></div>
      <div class="roomOut btn" @click="roomIO('out')"></div>
    </div>
    <div class="container">
      <img class="img" :src="src" :width="`${100 * room}%`"/>
    </div>
  </el-dialog>
</template>

<script>
import { Dialog } from 'element-ui';

export default {
  name: 'BigImageDialog',
  components: {
    ElDialog: Dialog,
  },
  data() {
    return {
      active: false,
      src: '',
      room: 1,
    };
  },
  methods: {
    openDialog(src) {
      this.src = src;
      this.room = 1;
      this.active = true;
    },
    roomIO(type) {
      switch (type) {
        case 'in':
          this.room = Math.min(3, this.room + 0.2);
          break;
        case 'out':
          this.room = Math.max(0.2, this.room - 0.2);
          break;
        default:
          break;
      }
    },
  },
};
</script>

<style lang="less" scoped>
@import "~@/assets/less/mixin.less";

.container {
  width: 100%;
  height: 488px;
  overflow: auto;
  position: relative;
  text-align: center;
  vertical-align: middle;
}
.btn {
  width: 20px;
  height: 20px;
  cursor: pointer;
  background-size: contain;
  &+& {
    margin-left: 12px;
  }
  &.roomIn {
    .bg-img("~@/assets/images/roomIn")
  }
  &.roomOut {
    .bg-img("~@/assets/images/roomOut")
  }
}
.btn-container {
  display: flex;
  margin-bottom: 12px;
}
.bigImageDialog {
  /deep/.el-dialog {
    border-radius: 7px;
    &__title {
      font-size:24px;
      font-family:PingFangSC-Medium,PingFang SC;
      font-weight:500;
      color:rgba(51,51,51,1);
      line-height:33px;
    }
    .el-dialog__header {
      padding-top: 25px
    }
    &__body {
      padding: 2px 40px 28px;
    }
    .el-dialog__headerbtn {
      top: 13px;
      right: 13px;
    }
    .el-dialog__close.el-icon.el-icon {
      width: 18px;
      height: 18px;
      font-size: 18px;
      &:before {
        content: '';
        width: 18px;
        height: 18px;
        display: block;
        .bg-img('~@/assets/images/close');
        background-size: contain;
      }
    }
  }
}
</style>
